import { createReducer } from "reduxsauce";

import UIDs from "../../../UIDs";
import _ from "lodash";
import ReducerRegister from "../../ReducerRegister";
import { ActionTypes } from "../../actionTypes/screens/talkchinese/PracticeActionTypes";
import { ActionTypes as RecordSettingActionTypes } from "../../actionTypes/screens/course/RecordSettingActionTypes";
import PracticeService from "../../../services/screens/talkchinese/PracticeService";
import AsyncActionReducers from "../../AsyncActionReducers";

//
// Actions
//
const Actions = {
    loadScreenViewAsync: searchVO => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            PracticeService.loadScreenView(
                searchVO,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, searchVO));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, searchVO) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        searchVO
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),


    showFooter: val => ({
        type: ActionTypes.SHOW_FOOTER,
        val,
    }),

    showCommonModalRef: val => ({
        type: ActionTypes.SHOW_COMMON_MODAL_REF,
        val,
    }),

    reportResult: (result, needReport) => ({
        type: ActionTypes.REPORT_RESULT,
        result,
        needReport
    }),

    nextUnit: () => ({
        type: ActionTypes.NEXT_UNIT,
    }),

    updateUnitResultAsync: vo => {
        return (dispatch, getState) => {
            dispatch({ type: ActionTypes.UPDATE_UNIT_RESULT_ASYNC });

            PracticeService.updateUnitResult(
                vo,
                response => {
                    dispatch(Actions.updateUnitResultSuccess(response));
                },
                error => {
                    dispatch(Actions.updateUnitResultFailure(error));
                }
            );
        };
    },

    updateUnitResultSuccess: data => ({
        type: ActionTypes.UPDATE_UNIT_RESULT_SUCCESS,
        parentType: ActionTypes.UPDATE_UNIT_RESULT_ASYNC,
        postReducer: updateUnitResultSuccessReducer,
        data,
    }),

    updateUnitResultFailure: error => ({
        type: ActionTypes.UPDATE_UNIT_RESULT_FAILURE,
        parentType: ActionTypes.UPDATE_UNIT_RESULT_ASYNC,
        error,
    }),

    reviewUnitAsync: vo => {
        return (dispatch, getState) => {
            dispatch({ type: ActionTypes.REVIEW_UNIT_ASYNC });

            PracticeService.reviewUnit(
                vo,
                response => {
                    dispatch(Actions.reviewUnitSuccess(response));
                },
                error => {
                    dispatch(Actions.reviewUnitFailure(error));
                }
            );
        };
    },

    reviewUnitSuccess: data => ({
        type: ActionTypes.REVIEW_UNIT_SUCCESS,
        parentType: ActionTypes.REVIEW_UNIT_ASYNC,
        data,
    }),

    reviewUnitFailure: error => ({
        type: ActionTypes.REVIEW_UNIT_FAILURE,
        parentType: ActionTypes.REVIEW_UNIT_ASYNC,
        error,
    }),

    updateSettings: settings => ({
        type: ActionTypes.UPDATE_SETTINGS,
        settings
    }),

    showPracticeResult: val => ({
        type: ActionTypes.SHOW_PRACTICE_RESULT,
        val
    }),

    restartAsync: vo => {
        return (dispatch, /* getState */) => {
            dispatch({ type: ActionTypes.RESTART_ASYNC });

            PracticeService.restart(
                vo,
                response => {
                    dispatch(Actions.restartSuccess(response, vo));
                },
                error => {
                    dispatch(Actions.restartFailure(error));
                }
            );
        };
    },

    restartSuccess: (data, { unitId }) => ({
        type: ActionTypes.RESTART_ASYNC_SUCCESS,
        parentType: ActionTypes.RESTART_ASYNC,
        postReducer: restartSuccessReducer,
        data,
        unitId
    }),

    restartFailure: error => ({
        type: ActionTypes.RESTART_ASYNC_FAILURE,
        parentType: ActionTypes.RESTART_ASYNC,
        error,
    }),

    completeAsync: vo => {
        return (dispatch, /* getState */) => {
            dispatch({ type: ActionTypes.COMPLETE_ASYNC });

            PracticeService.complete(
                vo,
                response => {
                    dispatch(Actions.completeSuccess(response));
                },
                error => {
                    dispatch(Actions.completeFailure(error));
                }
            );
        };
    },

    completeSuccess: (data) => ({
        type: ActionTypes.COMPLETE_ASYNC_SUCCESS,
        parentType: ActionTypes.COMPLETE_ASYNC,
        data,
    }),

    completeFailure: error => ({
        type: ActionTypes.COMPLETE_ASYNC_FAILURE,
        parentType: ActionTypes.COMPLETE_ASYNC,
        error,
    }),

    reviewRestart: () => ({
        type: ActionTypes.REVIEW_RESTART,
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    units: [],
    showFooter: false,
    showCommonModalRef: false,
    plan: null,
    startOn: null,
    pageIndex: null,
    unitResult: null,
    settings: {
        pinyinVisible: true,
        translationVisible: true,
        answerVisible: false,
        useLocalFilePath: false,
        talkChinese: true,
        recording: {
            showPinYin: 1,
            showTranslate: 0,
            playExample: 0,
            continuousPlay: 1,
            fixedLevel: false,
            autoStart: true,
        },
    },
    speechRecognitionSettings: {
        aliYunToken: {
            token: "",
            expireTime: 0,
        },
        aliYunIntToken: {
            token: "",
            expireTime: 0,
        },
    },
    showPracticeResult: false,
    isReporting: false,
    dialogCount: 0,
    wordsCount: 0,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, searchVO }) => {
    const { plan, units } = data;
    const { currentUnitIndex } = plan;

    let i = 0;
    let firstUnreviewedIndex = 0;
    for (i = 0; i < units.length; ++i) {
        if (!units[i].isReviewed) {
            firstUnreviewedIndex = i;
            break;
        }
    }
    return {
        ...state,
        plan,
        units,
        showFooter: false,
        showCommonModalRef: false,
        pageIndex: searchVO.type === 1 ? firstUnreviewedIndex : currentUnitIndex,
        startOn: new Date().getTime(),
        unitResult: null,
        totalUnitCount: units.length,
        showPracticeResult: false,
        settings: { ...state.settings, useLocalFilePath: data.useLocalFilePath || false, recording: data.recordConfig ? {...state.settings.recording, ...data.recordConfig} : state.settings.recording },
        speechRecognitionSettings: { ...state.speechRecognitionSettings, aliYunToken: data.aliYunToken, aliYunIntToken: data.aliYunIntToken },
    };
};

const showFooterReducer = (state, { val }) => {
    return { ...state, showFooter: val };
};

const showCommonModalRefReducer = (state, { val }) => {
    return { ...state, showCommonModalRef: val };
};

const reportResultReducer = (state, { result, needReport }) => {
    return { ...state, unitResult: { ...result, startOn: state.startOn, endOn: new Date().getTime() }, isReporting: needReport };
};

const nextUnitReducer = (state, { }) => {
    let settings = state.settings;
    let pageIndex = state.pageIndex + 1;
    return { ...state, pageIndex, startOn: new Date().getTime(), showFooter: false, showCommonModalRef: false, showPracticeResult: false, settings: { ...settings, recording: { ...state.settings.recording } } };
};

const updateSettingsReducer = (state, { settings }) => {
    return { ...state, settings };
};

const saveRecordSettingSuccessPostReducer = (state, { data }) => {
    return {
        ...state,
        settings: { ...state.settings, recording: { ...state.settings.recording, ...data } },
    };
};

const updateUnitResultSuccessReducer = (state, { }) => {
    const { units, pageIndex } = state;
    let newUnits = _.clone(units);
    if (newUnits[pageIndex]) {
        newUnits[pageIndex].reportResultDone = true;
    }
    return { ...state, units: newUnits, isReporting: false };
}

const showPracticeResultReducer = (state, { val }) => {
    return { ...state, showPracticeResult: val }
}

const restartSuccessReducer = (state, { unitId }) => {
    return { ...state, showPracticeResult: false, showFooter: false, showCommonModalRef: false }
}

const reviewRestartReducer = (state) =>{
    return { ...state, showPracticeResult: false, showFooter: false, showCommonModalRef: false, showPracticeResult: false, isReporting: false, }
}
// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REPORT_RESULT]: reportResultReducer,
    [ActionTypes.SHOW_FOOTER]: showFooterReducer,
    [ActionTypes.SHOW_COMMON_MODAL_REF]: showCommonModalRefReducer,
    [ActionTypes.NEXT_UNIT]: nextUnitReducer,
    [ActionTypes.UPDATE_UNIT_RESULT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPDATE_UNIT_RESULT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPDATE_UNIT_RESULT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REVIEW_UNIT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REVIEW_UNIT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REVIEW_UNIT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_SETTINGS]: updateSettingsReducer,
    [RecordSettingActionTypes.SAVE_RECORD_SETTING_SUCCESS]: saveRecordSettingSuccessPostReducer,
    [ActionTypes.SHOW_PRACTICE_RESULT]: showPracticeResultReducer,
    [ActionTypes.RESTART_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.RESTART_ASYNC_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.RESTART_ASYNC_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.COMPLETE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.COMPLETE_ASYNC_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.COMPLETE_ASYNC_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REVIEW_RESTART]: reviewRestartReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.screens.talkchinese.practice, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
